import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, useMessage } from '../global-components/src';

interface ModeratorRouteProps {
    children: React.ReactNode; // Recebe os filhos que serão protegidos
}

const ModeratorRoute: React.FC<ModeratorRouteProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    const { setMessage } = useMessage();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />; // Redireciona para login se não autenticado
    }

    if(!user?.position && (!user?.id || user?.id >= 5)){
        setMessage("Acesso negado", "error");
        return <Navigate to="/" replace />;
    }

    return <>{children}</>; // Retorna os filhos se autenticado
};

export default ModeratorRoute;
